module.exports = __webpack_public_path__ + "assets/img/ban2.6350f227.jpg";